/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useRef } from 'react';
import classNames from 'classnames';

import styles from './Textarea.module.scss';

interface TextareaProps {
  className?: string;
  dataTestId?: string;
  id?: string;
  label: string;
  maxLength?: number;
  name: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  shouldHideLabel?: boolean;
  value: string;
}

function Textarea({
  className,
  dataTestId,
  id,
  label,
  maxLength,
  name,
  onChange = () => {},
  placeholder,
  shouldHideLabel,
  value,
}: TextareaProps) {
  const textAreaRef = useRef<HTMLTextAreaElement>(null);

  const currentValueLength = textAreaRef.current?.value.length || 0;

  return (
    <div className={classNames(className, styles.inputWrapper)}>
      <label
        className={classNames(styles.label, {
          [styles.hideLabel]: shouldHideLabel,
        })}
        htmlFor={name}
      >
        {label}
      </label>
      <textarea
        data-testid={dataTestId}
        ref={textAreaRef}
        placeholder={placeholder}
        id={id || name}
        value={value}
        maxLength={maxLength}
        onChange={(e) => onChange(e.target.value)}
        className={styles.input}
      />
      {!!maxLength && (
        <span className={styles.characterLimit}>
          {currentValueLength}/{maxLength}
        </span>
      )}
    </div>
  );
}

export default Textarea;
